import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./Product.module.css";
import Accordion from "../../Components/Accordion/Accordion";
import API_BASE_URL from "../../config/api";
import Carna from "../ProductDetail/Carna/Carna";
import FalconS from "../ProductDetail/FalconS/FalconS";
import Familie from "../ProductDetail/Familie/Familie";
import Phantom from "../ProductDetail/Phantom/Phantom";
import Quantum from "../ProductDetail/Quantum/Quantum";
import Eden from "../ProductDetail/Eden/Eden";

const Product = () => {
  const { slug } = useParams();           // ← Changed from id to slug
  console.log("Current slug:", slug);
  const [product, setProduct] = useState(null);
  const [generalInfo, setGeneralInfo] = useState([]);
  const [images, setImages] = useState([]);
  const [detailsImages, setDetailsImages] = useState([]);
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    appendDots: (dots) => <ul>{dots}</ul>,
    customPaging: (i) => <div className="dot-line"></div>,
  };

  // Fetch product details using slug instead of id
  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!slug) return;

      try {
        const response = await fetch(
          `${API_BASE_URL}/fetchProductDetails.php?slug=${slug}`
        );
        const data = await response.json();

        if (data && data.product) {
          setProduct(data.product);
          setGeneralInfo(data.generalInfo || []);
          setImages(data.images || []);
          setDetailsImages(data.detailsImages || []);
        } else {
          console.warn("Product not found for slug:", slug);
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProductDetails();
  }, [slug]);

  // Render details images (video or image)
  const renderDetailsImages = () => {
    return detailsImages.map((imgUrl, index) => {
      const isVideo = imgUrl.endsWith(".mp4");
      return isVideo ? (
        <video
          key={index}
          src={`${API_BASE_URL}/${imgUrl}`}
          autoPlay
          loop
          playsInline
          muted
          className={styles.product_display_img}
        >
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          key={index}
          src={`${API_BASE_URL}/${imgUrl}`}
          alt={`Detail Image ${index + 1}`}
          className={styles.product_display_img}
        />
      );
    });
  };

  const handleToggleAccordion = (index) => {
    setOpenAccordionIndex(index === openAccordionIndex ? null : index);
  };

  const toggleViewMore = () => {
    setIsExpanded((prev) => !prev);
  };

  // Check if product info table should be shown
  const isProductInfoEmpty = (product) => {
    const fieldsToCheck = [
      "product_model", "kneading", "kneading_interval", "rated_voltage",
      "power_consumption", "auto_timer", "remote_control", "airbag",
      "rolling_range", "massage_ball", "heat_area", "speaker", "usb",
      "weight", "upright_dimension", "reclined_dimension",
      "safety_certification_no", "registration_no", "manufacturer_requestor",
      "manufacturer", "origin", "launched",
    ];

    return fieldsToCheck.every((field) => !product[field]);
  };

  const renderProductDetails = (product) => {
    const productDetails = [
      { title: "Product Model", value: product.product_model },
      { title: "Kneading", value: product.kneading },
      { title: "Kneading Interval", value: product.kneading_interval },
      { title: "Rated Voltage", value: product.rated_voltage },
      { title: "Power Consumption", value: product.power_consumption },
      { title: "Auto Timer", value: product.auto_timer },
      { title: "Remote Control", value: product.remote_control },
      { title: "Airbag", value: product.airbag },
      { title: "Rolling Range", value: product.rolling_range },
      { title: "Massage Ball", value: product.massage_ball },
      { title: "Massage Modes", value: product.massage_modes },
      { title: "Heat Area", value: product.heat_area },
      { title: "Speaker", value: product.speaker },
      { title: "USB", value: product.usb },
      { title: "Weight", value: product.weight },
      { title: "Upright Dimension", value: product.upright_dimension },
      { title: "Reclined Dimension", value: product.reclined_dimension },
      { title: "Safety Certification Number", value: product.safety_certification_no },
      { title: "Registration Number", value: product.registration_no },
      { title: "Manufacturer Requestor", value: product.manufacturer_requestor },
      { title: "Manufacturer", value: product.manufacturer },
      { title: "Origin", value: product.origin },
      { title: "Launch", value: product.launched },
    ].filter((detail) => detail.value);

    return productDetails.map((detail, index) => (
      <tr key={index}>
        <td className={styles.tableRowTitle}>{detail.title}</td>
        <td>{detail.value}</td>
      </tr>
    ));
  };

  if (!product) {
    return <div className={styles.loading}>Loading product details...</div>;
  }

  return (
    <div className={styles.wrap_all_content}>
      <div className={styles.product_details_container}>
        {/* Image Slider */}
        <div className={styles.product_image_container}>
          {images.length > 0 ? (
            <Slider {...sliderSettings}>
              {images.map((imgUrl, index) => (
                <div key={index}>
                  <img
                    src={`${API_BASE_URL}/uploads/productImages/${imgUrl}`}
                    alt={`Product Slide ${index + 1}`}
                  />
                </div>
              ))}
            </Slider>
          ) : (
            <p>No images available</p>
          )}
        </div>

        {/* Product Info */}
        <div className={styles.product_info}>
          <div className={styles.general_info_top}>
            <span className={styles.product_type}>{product.product_type}</span>
            <span className={styles.product_name}>{product.name}</span>
          </div>

          <div className={styles.general_info_section}>
            {generalInfo && generalInfo.length > 0 ? (
              generalInfo.map((info, index) => (
                <div key={index} className={styles.general_info_item}>
                  <h4>{info.title}</h4>
                  <p>{info.content}</p>
                </div>
              ))
            ) : (
              <p>No general information available.</p>
            )}
          </div>
        </div>
      </div>


{/* Product brochure */}

{slug === "bodyfriend-carna" ? (
  <Carna />
) : slug === "bodyfriend-falcon-s" ? (
  <FalconS />
) : slug === "bodyfriend-familie" ? (
  <Familie />
) : slug === "bodyfriend-phantom-rovo" ? (
  <Phantom />
) : slug === "bodyfriend-quantum" ? (
  <Quantum />
) : slug === "bodyfriend-eden" ? (
  <Eden />
) : (
  detailsImages.length > 0 && (
    <div
      className={`${styles.display_img_container} ${
        isExpanded ? styles.expanded : ""
      }`}
    >
      {renderDetailsImages()}

      <div className={styles.view_more_section}>
        <button onClick={toggleViewMore}>
          {isExpanded ? "View Less" : "View More"}
        </button>
      </div>

      {product.brochure_pdf && (
        <a
          href={`${API_BASE_URL}/uploads/brochures/${product.brochure_pdf}`}
          download={product.brochure_pdf}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.download_button}
        >
          Download Brochure (PDF)
        </a>
      )}
    </div>
  )
)}
      {/* Product Details Accordion */}
      <div className={styles.product_details_wrap}>
        <div className={styles.accordion_section}>
          {!isProductInfoEmpty(product) && (
            <Accordion
              title="Product Information"
              content={
                <table className={styles.table_bordered}>
                  <tbody>{renderProductDetails(product)}</tbody>
                </table>
              }
              isOpen={openAccordionIndex === 0}
              toggleAccordion={() => handleToggleAccordion(0)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;